'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { useRef, useEffect } from 'react';
import { DynamicError, DeferredPromise } from '@dynamic-labs/utils';
import '../../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/sdk-api-core';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../constants/colors.js';
import '../../constants/values.js';
import '../../../shared/consts/index.js';
import '../../../events/dynamicEvents.js';
import '../../../context/CaptchaContext/CaptchaContext.js';
import '../../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import '../../../store/state/nonce/nonce.js';
import { useProjectSettings } from '../../../store/state/projectSettings/projectSettings.js';
import '../../../config/ApiEndpoint.js';
import '../../../store/state/user/user.js';
import '../../../locale/locale.js';
import '../../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../../store/state/primaryWalletId/primaryWalletId.js';
import { rejectPromiseRef } from '../../functions/rejectPromiseRef/rejectPromiseRef.js';
import '../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../context/AccountExistsContext/AccountExistsContext.js';
import '../../../context/UserWalletsContext/UserWalletsContext.js';
import '../../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../functions/compareChains/compareChains.js';
import '../../../context/ThemeContext/ThemeContext.js';
import '../useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import '@dynamic-labs/types';
import '../../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../../context/LoadingContext/LoadingContext.js';
import '../../../context/WalletContext/WalletContext.js';
import '../useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import 'yup';
import '../../../context/MockContext/MockContext.js';
import '../../../views/CollectUserDataView/useFields.js';
import '../../../context/FieldsStateContext/FieldsStateContext.js';
import '../../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../../store/state/loadingAndLifecycle.js';
import '../../../store/state/walletOptions/walletOptions.js';
import 'react-i18next';
import '../../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../../../components/Alert/Alert.js';
import '../../../components/ShadowDOM/ShadowDOM.js';
import '../../../components/IconButton/IconButton.js';
import '../../../components/InlineWidget/InlineWidget.js';
import '../../../components/Input/Input.js';
import '../../../components/IsBrowser/IsBrowser.js';
import '../../../components/MenuList/Dropdown/Dropdown.js';
import '../../../components/OverlayCard/OverlayCard.js';
import '../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../../components/Popper/Popper/Popper.js';
import '../../../components/Popper/PopperContext/PopperContext.js';
import 'react-focus-lock';
import 'qrcode';
import 'formik';
import '../useSubdomainCheck/useSubdomainCheck.js';
import '../../../context/WalletGroupContext/WalletGroupContext.js';
import '../../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../../context/ConnectWithOtpContext/ConnectWithOtpContext.js';
import '../../../context/ConnectWithOtpContext/constants.js';
import '../../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '@hcaptcha/react-hcaptcha';
import '../../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../../context/FooterAnimationContext/index.js';
import '../../../context/PasskeyContext/PasskeyContext.js';
import '../../../store/state/sendBalances.js';
import '../../../components/OverlayCardBase/OverlayCardTarget/OverlayCardTarget.js';
import '../../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import '../../../views/TransactionConfirmationView/TransactionConfirmationView.js';
import '../../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import { useOnrampContext } from '../../../context/OnrampContext/OnrampContext.js';
import { useConnectWalletForFunding } from './useConnectWalletForFunding/useConnectWalletForFunding.js';
import '../../../widgets/DynamicWidget/views/ReceiveExternalWalletFunds/ReceiveExternalWalletFunds.js';
import '../../../../index.js';
import '../../../store/state/tokenBalances.js';
import '../../../shared/utils/functions/getInitialUrl/getInitialUrl.js';
import { useInternalDynamicContext } from '../../../context/DynamicContext/useDynamicContext/useInternalDynamicContext.js';

const useFunding = () => {
    var _a, _b;
    const promiseRef = useRef(null);
    const { setSelectedOnrampProvider, setEnabledOnrampProvidersTarget, setShowOnramp, onrampEnabled, showOnramp, } = useOnrampContext();
    const projectSettings = useProjectSettings();
    const externalWalletFundingEnabled = Boolean((_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.funding) === null || _a === void 0 ? void 0 : _a.externalWallets) === null || _b === void 0 ? void 0 : _b.enabled);
    const { primaryWallet } = useInternalDynamicContext();
    const fundWithExternalWallet = (_c) => __awaiter(void 0, [_c], void 0, function* ({ amount, fromWallet, token, }) {
        if (!externalWalletFundingEnabled) {
            throw new Error('External wallet funding is not enabled');
        }
        if (!amount || !fromWallet) {
            throw new Error('Amount and fromWallet are required');
        }
        if (!primaryWallet) {
            throw new Error('Primary wallet not found');
        }
        const fromWalletNetwork = yield fromWallet.getNetwork();
        const primaryWalletNetwork = yield primaryWallet.getNetwork();
        if (!fromWalletNetwork || !primaryWalletNetwork) {
            throw new Error('Wallet network not found');
        }
        if (fromWalletNetwork !== primaryWalletNetwork) {
            yield fromWallet.switchNetwork(primaryWalletNetwork);
        }
        const toAddress = primaryWallet.address;
        return fromWallet.sendBalance({
            amount: amount.toString(),
            toAddress,
            token,
        });
    });
    const openOnramp = (_d) => __awaiter(void 0, [_d], void 0, function* ({ onrampProvider, address, token, }) {
        if (!onrampEnabled) {
            throw new Error('Onramp is not enabled');
        }
        if (promiseRef.current) {
            return promiseRef.current.promise;
        }
        promiseRef.current = new DeferredPromise();
        if (address || token)
            setEnabledOnrampProvidersTarget({ address, token });
        setSelectedOnrampProvider(onrampProvider);
        setShowOnramp(true);
        return promiseRef.current.promise;
    });
    useEffect(() => {
        if (!showOnramp && promiseRef.current) {
            rejectPromiseRef(promiseRef, new DynamicError('User cancelled'));
        }
    }, [showOnramp]);
    const connectWalletForFunding = useConnectWalletForFunding({
        externalWalletFundingEnabled,
    });
    return {
        /**
         * Connects to an external wallet for funding.
         * If called with no arguments, it will open a wallet list selector.
         */
        connectWalletForFunding,
        /**
         * @deprecated use onrampEnabled instead
         */
        enabled: onrampEnabled,
        /**
         * Whether external wallet funding is enabled
         */
        externalWalletFundingEnabled,
        /**
         * Triggers a funding transaction from an external wallet to the primary wallet
         */
        fundWithExternalWallet,
        /**
         * Whether some onramp method is enabled
         */
        onrampEnabled,
        /**
         * @deprecated use openOnramp instead
         */
        openExternalFunding: openOnramp,
        /**
         * Opens the onramp modal
         */
        openOnramp,
    };
};

export { useFunding };
